
import { defineComponent } from 'vue'
import { SampleWebhookPayload } from '../../models/SampleWebhookPayload'
export default defineComponent({
    name: "WebHooks",
    setup() {
        const GetGuid = () => {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        }
        
        let sampleWebhookPayload = new SampleWebhookPayload(GetGuid());
        
        return {
            sampleWebhookPayload
        }
    },
    methods: {
        sendPayload() {
            this.$store.state.axiosService.PostSampleWebhookPayload(this.sampleWebhookPayload);
        }
    }
})
